function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "internet",
  transform: "translate(-350.375 -408.328)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_14",
  "data-name": "Path 14",
  transform: "translate(351.061 408.328)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H4.658V3.344H0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 0.4000034332275391 0.3999950885772705 L 0.4000034332275391 2.943744897842407 L 4.257802963256836 2.943744897842407 L 4.257802963256836 0.3999950885772705 L 0.4000034332275391 0.3999950885772705 M 3.337860107421875e-06 -5.006790161132813e-06 L 4.657803058624268 -5.006790161132813e-06 L 4.657803058624268 3.343744993209839 L 3.337860107421875e-06 3.343744993209839 L 3.337860107421875e-06 -5.006790161132813e-06 Z",
  stroke: "none",
  fill: "#1f1f1f"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_13",
  "data-name": "Path 13",
  transform: "translate(350.375 408.328)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 1.471877455711365 1.799999952316284 L 0.1999974995851517 1.799999952316284 L 0.1999974995851517 0.2000000029802322 L 1.471877455711365 0.2000000029802322 L 1.471877455711365 1.799999952316284 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 0.3999974727630615 0.3999999761581421 L 0.3999974727630615 1.600000023841858 L 1.271877527236938 1.600000023841858 L 1.271877527236938 0.3999999761581421 L 0.3999974727630615 0.3999999761581421 M -2.503395080566406e-06 0 L 1.671877503395081 0 L 1.671877503395081 2 L -2.503395080566406e-06 2 L -2.503395080566406e-06 0 Z",
  stroke: "none",
  fill: "#1f1f1f"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_4",
  "data-name": "Line 4",
  x2: 1.5,
  transform: "translate(350.5 409.2)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_5",
  "data-name": "Line 5",
  y2: 0.5,
  transform: "translate(351.211 409.178)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_6",
  "data-name": "Line 6",
  y2: 2.68,
  transform: "translate(351.25 410)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_7",
  "data-name": "Line 7",
  y2: 1.3,
  transform: "translate(353.25 411.34)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_8",
  "data-name": "Line 8",
  x1: 2.4,
  transform: "translate(352.1 412.5)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeWidth: 0.35
}));

function SvgInternet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.344,
    height: 4.352,
    viewBox: "0 0 5.344 4.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.af8783fb.svg";
export { ForwardRef as ReactComponent };